import { isEmpty } from 'lodash';

const resolveSortBy = ({ rawVal }: any) => {
  if (isEmpty(rawVal)) {
    return undefined;
  }

  return Object.keys(rawVal).map((key: string) => ({ key, value: rawVal[key] }));
};

export default resolveSortBy;
